import { render, staticRenderFns } from "./HyphenTable.vue?vue&type=template&id=ab7c7f34&scoped=true"
import script from "./HyphenTable.vue?vue&type=script&setup=true&lang=js"
export * from "./HyphenTable.vue?vue&type=script&setup=true&lang=js"
import style0 from "./HyphenTable.vue?vue&type=style&index=0&id=ab7c7f34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab7c7f34",
  null
  
)

export default component.exports